import Big from "big.js"

export function initMath() {
    Big.DP = 36 // NOTE: this need to align to the maximum decimals of our vault token
    Big.RM = Big.roundDown
}
